module.exports = __webpack_public_path__ + "static/media/SleepTreatment.723fdc6c.png";